// © Microsoft Corporation. All rights reserved.

export function registerVideoPlayStarted(onPlayCallback: (evt: any) => void) {
    const vids = Array.from(document.querySelectorAll("video"));
    let lastClickTime = 0;
    document.addEventListener("click", e => lastClickTime = e.timeStamp);
    vids.map(v => v.addEventListener("play", e => e.timeStamp - lastClickTime < 50 && onPlayCallback(e)));
}

export function unregisterVideoPlayStarted(onPlayCallback: (evt: any) => void) {
    const vids = Array.from(document.querySelectorAll("video"));
    vids.map(v => v.removeEventListener("play", onPlayCallback));
}